// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"de0d7530","494":"1828b08d","900":"00b0f4fe"}[chunkId] + ".chunk.js";
};